<template>
    <div class="row g-3 mb-4">
        <div class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer" @click="toggleSection">
            <h6 class="fw-bold mb-0">1. Podstawowe dane i przynależność</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>
        <div class="col-12" v-show="sectionCollapse">
            <div class="row g-3">
                <!-- TYP DOKUMENTU -->
                <div class="col-md-4">
                    <label class="form-label fw-semibold">Typ faktury</label>
                    <select class="form-select" v-model="form.invoiceType" required>
                        <option value="" disabled selected>-- Wybierz typ faktury --</option>
                        <option value="vat">Faktura VAT</option>
                        <option value="marza">Faktura VAT Marża</option>
                    </select>
                </div>

                <!-- NUMER DOKUMENTU + LISTA OSTATNICH -->
                <div class="col-md-4">
                    <label class="form-label fw-semibold">Numer dokumentu</label>
                    <div class="input-group">
                        <input type="text" class="form-control" v-model="form.docNumber" placeholder="np. 1/2026" required />
                        <button class="btn btn-outline-secondary" type="button" title="Pobierz kolejny numer" @click="$emit('fetchNextDocNumber')">
                            <i class="bi bi-arrow-clockwise"></i>
                        </button>
                    </div>
                    <!-- Lista 3 ostatnich faktur z datą w tooltipie -->
                    <div class="form-text small mt-1" v-if="lastInvoices.length > 0">
                        <span class="text-muted">Ostatnie: </span><br>
                        <span 
                            v-for="(item, idx) in lastInvoices" 
                            :key="idx" 
                            class="badge bg-secondary me-1 cursor-pointer" 
                        >
                            {{ item.docNumber }} z {{ formatDate(item.createDate) }}
                        </span>
                    </div>
                </div>

                <!-- DATA WYSTAWIENIA -->
                <div class="col-md-4">
                    <label class="form-label fw-semibold">Data wystawienia</label>
                    <input type="date" class="form-control" v-model="form.issueDate" required />
                </div>

                <!-- MIEJSCE WYSTAWIENIA -->
                <div class="col-md-4">
                    <label class="form-label fw-semibold">Miejsce wystawienia</label>
                    <input type="text" class="form-control" v-model="form.issuePlace" placeholder="" />
                </div>

                <!-- DATA SPRZEDAŻY -->
                <div class="col-md-4">
                    <label class="form-label fw-semibold">Data sprzedaży (data i czas)</label>
                    <input type="datetime-local" class="form-control" v-model="form.saleDate" required />
                </div>

                <!-- BDO -->
                <div class="col-md-4">
                    <label class="form-label fw-semibold">BDO</label>
                    <input type="text" class="form-control" v-model="form.bdo" placeholder="" />
                </div>

                <!-- CHECKBOXY NA DOLE (JEDEN POD DRUGIM) -->
                <div class="col-12">
                    <div class="form-check mb-2">
                        <input class="form-check-input" type="checkbox" id="variantCheck" v-model="form.isVariantOption" />
                        <label class="form-check-label" for="variantCheck">Oznaczenie wariantu dokumentu</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="marginCheck" v-model="form.isMarginProcedure" />
                        <label class="form-check-label" for="marginCheck">Procedura marży</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'

const props = defineProps({
    modelValue: {
        type: Object,
        required: true
    },
    lastInvoices: {
        type: Array,
        default: () => []
    }
})

const formatDate = (dateStr) => {
    if (!dateStr) return ''
    
    // Jeśli data przychodzi w formacie YYYY-MM-DD
    const parts = dateStr.split('-')
    if (parts.length === 3) {
        const [year, month, day] = parts
        return `${day}.${month}.${year}`
    }
    
    return dateStr
}
const emit = defineEmits(['update:modelValue', 'fetchNextDocNumber'])

const form = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

// Automatyczna zmiana checkboxa procedury marży w zależności od typu faktury
watch(() => form.value.invoiceType, (newType) => {
    if (newType === 'marza') {
        form.value.isMarginProcedure = true
    } else if (newType === 'vat') {
        form.value.isMarginProcedure = false
    }
})

const sectionCollapse = ref(true)
const headerRef = ref(null)

const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value

    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}
</style>